<script setup lang="ts">
import { generateAbsoluteLink } from "@/lib/utils.js"

const link = generateAbsoluteLink("files/Nuove_norme_2022.pdf")
</script>

<template>
  <p class="mb-8 text-lg">
    Studi Musicali pubblica articoli riguardanti tutti i campi della ricerca musicologica in italiano, inglese,
    francese, tedesco e spagnolo. Gli autori possono inviare gli articoli in formato digitale all'indirizzo:
    <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a>,
    <a href="mailto:tgialdroni@gmail.com" class="classic-link">tgialdroni@gmail.com</a>. La pubblicazione è subordinata
    al parere di due studiosi specializzati (referee) ai quali l'articolo sarà sottoposto in forma anonima. Una volta
    accettato, l'articolo dovrà essere redatto secondo le
    <a :href="link" class="classic-link" target="_blank">Norme editoriali</a> della rivista - disponibili su questa
    pagina - dove sono riportate anche tutte le informazioni relative ai formati e alla risoluzione di eventuali
    immagini di corredo e di eventuali esempi musicali. Sarà comunicata all'autore l'avvenuta accettazione per la
    pubblicazione e sarà anche specificata una data orientativa di pubblicazione, tenendo presente che la rivista è
    semestrale e che di regola il primo fascicolo è pubblicato entro l'anno di riferimento e il secondo entro i primi
    mesi dell'anno successivo.
  </p>
</template>
